import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'numeroParaHora'
})
export class NumeroParaHoraPipe implements PipeTransform {

  transform(value: any): string {
    if (value === undefined || value === null) {
      return '--:--';
    }

    let numero: number | undefined;

    if (Number.isNaN(value)) {
      numero = parseInt(value);
    } else {
      numero = parseInt(value.toString().replace(/[: ]+/g, ''));
    }

    if (Number.isNaN(numero)) {
      return '--:--';
    }

    let timeString = numero.toString().padStart(4, '0').slice(0, 4);
    return `${timeString.slice(0, -2)}:${timeString.slice(-2)}`;
  }

}
